/** @format */
import Vue from "vue";
import VueRouter from "vue-router";
import Auth from "../Auth.js";
import user from "../middleware/user.js";
import auth from "../middleware/auth.js";

Vue.use(VueRouter);

import DashboardLayout from "../components/Dashboard/Layout/DashboardLayout.vue";
import NotFound from "../components/GeneralViews/NotFoundPage.vue";
import Login from "src/components/Dashboard/Views/Pages/Login.vue";
import PasswordReset from "src/components/Dashboard/Views/Password/Reset.vue";
import PasswordEmail from "src/components/Dashboard/Views/Password/Email.vue";

import listRole from "../components/Admin/Role/listRole.vue";
import addRole from "../components/Admin/Role/addRole.vue";
import editRole from "../components/Admin/Role/editRole.vue";

import listUser from "../components/Admin/User/listUser.vue";
import addUser from "../components/Admin/User/addUser.vue";
import editUser from "../components/Admin/User/editUser.vue";
import Profile from "../components/Admin/User/Profile.vue";

import listCategory from "../components/Admin/Category/listCategory.vue";
import addCategory from "../components/Admin/Category/addCategory.vue";
import editCategory from "../components/Admin/Category/editCategory.vue";

import listSubcategory from "../components/Admin/Subcategory/listSubcategory.vue";
import addSubcategory from "../components/Admin/Subcategory/addSubcategory.vue";
import editSubcategory from "../components/Admin/Subcategory/editSubcategory.vue";

import listProduct from "../components/Admin/Product/listProduct.vue";
import addProduct from "../components/Admin/Product/addProduct.vue";
import editProduct from "../components/Admin/Product/editProduct.vue";

import addPromotion from "../components/Admin/Promotion/addPromotion.vue";
import editPromotion from "../components/Admin/Promotion/editPromotion.vue";
import listPromotion from "../components/Admin/Promotion/listPromotion.vue";

import addReferral from "../components/Admin/Referral/addReferral.vue";
import editReferral from "../components/Admin/Referral/editReferral.vue";
import listReferral from "../components/Admin/Referral/listReferral.vue";

import wishlist from "../components/Admin/Wishlist/wishlist.vue";
import wishlistDetail from "../components/Admin/Wishlist/wishlistDetail.vue";
import cart from "../components/Admin/Cart/cart.vue";
import cartDetail from "../components/Admin/Cart/cartDetail.vue";

import listLead from "../components/Admin/Lead/listLead.vue";
import addLead from "../components/Admin/Lead/addLead.vue";
import editLead from "../components/Admin/Lead/editLead.vue";
import editNote from "../components/Admin/Lead/editNote.vue";

import listOrders from "../components/Admin/Orders/listOrders.vue";
import orderDetails from "../components/Admin/Orders/orderDetails.vue";

import listCustomer from "../components/Admin/Customer/listCustomer.vue";
import addCustomer from "../components/Admin/Customer/addCustomer.vue";
import editCustomer from "../components/Admin/Customer/editCustomer.vue";

import addOfflineOrder from "../components/Admin/OfflineOrder/addOfflineOrder.vue";
import listOfflineorder from "../components/Admin/OfflineOrder/listOfflineorder.vue";
import editOfflineOrder from "../components/Admin/OfflineOrder/editOfflineOrder.vue";

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/admin/dashboard",
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      middleware: [user],
    },
  },

  //Admin Dashboard
  {
    path: "/admin/dashboard",
    component: DashboardLayout,
    meta: {
      middleware: [auth],
    },
  },

  //Role
  {
    path: "/admin/dashboard/role",
    component: listRole,
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/admin/dashboard/addrole",
    component: addRole,
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/admin/dashboard/editrole/:id",
    component: editRole,
    meta: {
      middleware: [auth],
    },
  },

  //User
  {
    path: "/admin/dashboard/user",
    component: listUser,
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/admin/dashboard/adduser",
    component: addUser,
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/admin/dashboard/edituser/:id",
    component: editUser,
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/admin/dashboard/profile",
    component: Profile,
    meta: {
      middleware: [auth],
    },
  },
  //category
  {
    path: "/admin/dashboard/category",
    component: listCategory,
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/admin/dashboard/addcategory",
    component: addCategory,
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/admin/dashboard/editcategory/:id",
    component: editCategory,
    meta: {
      middleware: [auth],
    },
  },

  //Subcategory
  {
    path: "/admin/dashboard/subcategory",
    component: listSubcategory,
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/admin/dashboard/addsubcategory",
    component: addSubcategory,
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/admin/dashboard/editsubcategory/:id",
    component: editSubcategory,
    meta: {
      middleware: [auth],
    },
  },

  //Product
  {
    path: "/admin/dashboard/product",
    component: listProduct,
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/admin/dashboard/addproduct",
    component: addProduct,
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/admin/dashboard/editproduct/:id",
    component: editProduct,
    meta: {
      middleware: [auth],
    },
  },

  //Promotion
  {
    path: "/admin/dashboard/promotion",
    component: listPromotion,
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/admin/dashboard/addpromotion",
    component: addPromotion,
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/admin/dashboard/editpromotion/:id",
    component: editPromotion,
    meta: {
      middleware: [auth],
    },
  },

  //Referral
  {
    path: "/admin/dashboard/referral",
    component: listReferral,
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/admin/dashboard/addreferral",
    component: addReferral,
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/admin/dashboard/editreferral/:id",
    component: editReferral,
    meta: {
      middleware: [auth],
    },
  },

  //Wishlist
  {
    path: "/admin/dashboard/wishlist",
    component: wishlist,
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/admin/dashboard/wishlist-detail/:id",
    component: wishlistDetail,
    meta: {
      middleware: [auth],
    },
  },

  //Cart
  {
    path: "/admin/dashboard/cart",
    component: cart,
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/admin/dashboard/cart-detail/:id",
    component: cartDetail,
    meta: {
      middleware: [auth],
    },
  },

  //Lead
  {
    path: "/admin/dashboard/lead",
    component: listLead,
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/admin/dashboard/addlead",
    component: addLead,
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/admin/dashboard/editenquiry/:id",
    component: editLead,
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/admin/dashboard/editenquirynote/:id",
    component: editNote,
    meta: {
      middleware: [auth],
    },
  },

  //Orders
  {
    path: "/admin/dashboard/orders",
    component: listOrders,
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/admin/dashboard/orderdetail/:id",
    component: orderDetails,
    meta: {
      middleware: [auth],
    },
  },

  //Password Reset
  {
    path: "/password/email",
    name: "Password Reset Email",
    component: PasswordEmail,
  },

  {
    path: "/password/reset",
    name: "Password Reset",
    component: PasswordReset,
  },

  //Customer
  {
    path: "/admin/dashboard/customer",
    component: listCustomer,
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/admin/dashboard/addcustomer",
    component: addCustomer,
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/admin/dashboard/editcustomer/:id",
    component: editCustomer,
    meta: {
      middleware: [auth],
    },
  },

  //Customer
  {
    path: "/admin/dashboard/offlineorders",
    component: listOfflineorder,
    meta: {
      middleware: [auth],
    },
  },
  {
    path: "/admin/dashboard/addofflineorder",
    component: addOfflineOrder,
    meta: {
      middleware: [auth],
    },
  },
  {
    path: "/admin/dashboard/editofflineorder/:id",
    component: editOfflineOrder,
    meta: {
      middleware: [auth],
    },
  },

  { path: "*", component: NotFound },
];

export default routes;
